module.exports = __webpack_public_path__ + "img/signout.32c9f35d.svg";